import './StoreView.scss';
import React, { useState } from 'react';
import IMerchStore from '../../../models/restful/IMerchStore';
import StorePreview from './StorePreview/StorePreview';
import { generatePath, Link, useParams } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette, faRefresh } from '@fortawesome/free-solid-svg-icons';
import PATHS from '../../../paths';
import { apiV2 } from '../../../api/ApiV2';

interface IStoreViewProps {
  store?: IMerchStore;
}

const StoreView: React.FunctionComponent<IStoreViewProps> = (
  props: IStoreViewProps
) => {
  const [store, setStore] = useState<IMerchStore>(
    props.store || ({} as IMerchStore)
  );
  const { id } = useParams();
  const updateFromServer = () => {
    apiV2.crud
      .read({
        dataObjectName: 'MerchStore',
        id: `${id}`
      })
      .then(resp => {
        if (resp.item) {
          setStore(resp.item as IMerchStore);
        }
      });
  };
  if (!store.ID) {
    updateFromServer();
    return null;
  }

  return (
    <div className="store-view-cont">
      <div className="row pt-3 pb-2 mb-3 bstore-bottom">
        <div className="col-6">
          <h3 className="h2 pt-3">Store #{store.ID}</h3>
        </div>
        <div className="col-4"></div>
        <div className="col-2">
          <Link
            to="#"
            className="text-900 me-4 px-0"
            onClick={() => updateFromServer()}
          >
            <FontAwesomeIcon icon={faRefresh} className="fs-9 me-2" />
            Reload
          </Link>
          <Link to={generatePath(PATHS.STORES)} className="text-900 me-4 px-0">
            <FontAwesomeIcon icon={faPalette} className="fs-9 me-2" />
            All stores
          </Link>
        </div>
      </div>
      <StorePreview store={store} />
    </div>
  );
};

export default StoreView;
